import { css } from '@genesislcap/web-core';

export const landingStyles = css`
  :host {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: var(--neutral-layer-4);
    padding: 30px;
    box-sizing: border-box;
  }

  .landing-container {
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: 40px;
    box-sizing: border-box;
    background: var(--neutral-layer-3);
    border-radius: 12px;
  }

  .landing-top-header {
    width: 100%;
    margin-bottom: 40px;
    animation: fadeInDown 0.6s ease-out;
  }

  .header-logo-section {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .header-logo {
    width: 48px;
    height: auto;
  }

  .header-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .header-bank-name {
    font-size: 1rem;
    font-weight: 600;
    color: var(--neutral-foreground-rest);
    letter-spacing: 0.5px;
  }

  .header-portal-name {
    font-size: 1.25rem;
    font-weight: 500;
    color: var(--neutral-foreground-rest);
  }

  .landing-header {
    margin-bottom: 60px;
    animation: fadeInDown 0.6s ease-out;
    font-size: 2rem;
    font-weight: 600;
    color: var(--neutral-foreground-rest);
    letter-spacing: -0.5px;
  }

  .landing-cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 40px;
    animation: fadeInUp 0.6s ease-out 0.2s both;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
  }

  .landing-card {
    background:
      radial-gradient(
        circle at top right,
        var(--accent-fill-rest-30),
        transparent 30%
      );
    border: 1px solid var(--neutral-stroke-rest);
    border-radius: 12px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .landing-card.card-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    filter: grayscale(0.8);
    pointer-events: none;
  }

  .landing-card:not(.card-disabled):hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.2);
    border-color: var(--accent-fill-rest);
  }

  .card-module-label {
    font-weight: 600;
    color: var(--accent-fill-rest);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    
    rapid-icon {
      color: var(--accent-fill-rest);
    }
  }

  .module-icon {
    width: 16px;
    height: 16px;
  }

  .card-title {
    font-size: 2rem;
    font-weight: 600;
    color: var(--neutral-foreground-rest);
    margin: 0 0 12px 0;
  }

  .card-description {
    font-size: 1rem;
    color: var(--neutral-foreground-hint);
    line-height: 1.6;
    margin: 0 0 12px 0;
  }

  .card-image-placeholder {
    width: 100%;
    background: var(--neutral-layer-2);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    position: relative;
  }

  .card-image-placeholder img {
    width: 100%;
  }

  .coming-soon-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: var(--accent-fill-rest);
    color: white;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .placeholder-text {
    color: var(--neutral-foreground-hint);
    font-size: 0.875rem;
    text-align: center;
    padding: 20px;
  }

  .card-button {
    min-width: 180px;
  }

  /* Animations */
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Responsive */
  @media (max-width: 768px) {
    .landing-container {
      padding: 24px;
    }

    .landing-title {
      font-size: 2rem;
    }

    .landing-cards {
      flex-direction: column;
      gap: 20px;
      width: 100%;
      max-width: 400px;
    }

    .landing-card {
      min-width: auto;
    }
  }
`;

